import isPlainObject from 'lodash/isPlainObject';
import { createActions } from '../../shared/actions';
import { alertCreator } from '../../shared/utils';
import {
  namespace,
  typeCreateRegistry
} from './constants';

const createRegistry = createActions(typeCreateRegistry, namespace, {
  failed: { metaCreator: alertCreator },
  original: {
    payloadCreator(data) {
      if (isPlainObject(data)) {
        return {
          ajaxOptions: {
            body: data,
            endpoint: '/registry/create',
            method: 'POST'
          }
        };
      }
    }
  },
  succeeded: {
    metaCreator: alertCreator,
    payloadCreator(payload) {
      if (isPlainObject(payload) && isPlainObject(payload.data)) {
        return payload.data;
      }
    }
  }
});

export default {
  ...createRegistry
};



// WEBPACK FOOTER //
// ./src/containers/TechniciansReportForm/actions.js